import { defineMessages } from 'react-intl'

export const reportingPeriodMessages = defineMessages({
  daily: {
    defaultMessage: 'Daily',
    description: 'periods',
  },
  hourly: {
    defaultMessage: 'Hourly',
    description: 'periods',
  },
  monthly: {
    defaultMessage: 'Monthly',
    description: 'periods',
  },
  weekly: {
    defaultMessage: 'Weekly',
    description: 'periods',
  },
})
